module.exports = __webpack_public_path__ + "img/telephone-filled.5fc61175.svg";